export default [
    '$scope',
    function InfoContactController() {
        return;
    }
];
